import { QRCodeSVG } from "qrcode.react";
import type React from "react";
import { useTranslation } from "react-i18next";

import { Spinner } from "@krea/shared/design-system/Spinner";

interface QRCodeAuthFlowProps {
  qrCode: string | null;
  isUserSign: boolean;
}

export const QRCodeAuthFlow: React.FC<QRCodeAuthFlowProps> = ({
  qrCode,
  isUserSign,
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: 290 }}>
      {!isUserSign && qrCode ? (
        <div className="mt-2 flex w-full flex-col items-center">
          <div className="relative flex flex-col items-center justify-center p-4">
            <QRCodeSVG size={200} value={qrCode} />

            <div className="absolute left-0 top-0 h-6 w-6 rounded-tl-xl border-l-4 border-t-4 border-primary" />

            <div className="absolute right-0 top-0 h-6 w-6 rounded-tr-xl border-r-4 border-t-4 border-primary" />

            <div className="absolute bottom-0 left-0 h-6 w-6 rounded-bl-xl border-b-4 border-l-4 border-primary" />

            <div className="absolute bottom-0 right-0 h-6 w-6 rounded-br-xl border-b-4 border-r-4 border-primary" />
          </div>
        </div>
      ) : (
        <Spinner />
      )}

      <div className="mt-6">
        <h6 className="pl-6 text-left">{t("bankID.SE.qrCodeInstructions")}:</h6>

        <ol className="max-w-[300px] list-decimal pl-10">
          <li>{t("bankID.SE.qrCodeStep1")}</li>
          <li>{t("bankID.SE.qrCodeStep2")}</li>
          <li>{t("bankID.SE.qrCodeStep3")}</li>
          <li>{t("bankID.SE.qrCodeStep4")}</li>
        </ol>
      </div>
    </div>
  );
};
